// السجل — شاشة تصحيح لا شاشة قراءة.
// وظيفتها الوحيدة: «سجّلت رقماً خاطئاً قبل دقيقتين، أين أصلحه؟»

import { fmt, esc, dayLabel } from '../util.js';
import { state, liveEntries, toBase, baseSym, destName } from '../store.js';
import { topBar, entryRow, emptyState, loadingBlock, offlineBlock, errorBlock } from '../ui.js';

// السجل شاشة تصحيح لا أرشيف: «سجّلت رقماً خاطئاً، أين أصلحه؟».
// تسعون يوماً تغطّي ذلك بمريح، وتُبقي الجلب خفيفاً. ما قبلها يُرى من التقرير
// بتحديد الفترة، وهو المكان الطبيعي للنظر في الماضي البعيد.
const SPAN_DAYS = 90;

export function rangeFor(){
  const to = Date.now();
  return { from: to - SPAN_DAYS * 86400000, to };
}

export function render(app){
  if (app.loading) return topBar('السجل', 'آخر ٩٠ يوماً') + loadingBlock('الحركات');
  if (app.dataErr === 'offline') return topBar('السجل', 'آخر ٩٠ يوماً') + offlineBlock('حركاتك السابقة');
  if (app.dataErr) return topBar('السجل', 'آخر ٩٠ يوماً') + errorBlock(app.dataErr);

  const list = liveEntries()
    .slice()
    .sort((a, b) => new Date(b.occurredAt) - new Date(a.occurredAt))
    .slice(0, 400);

  if (!list.length){
    return topBar('السجل', 'آخر ٩٠ يوماً')
      + `<div class="scroll">${emptyState('السجل فارغ',
          'سجّل أول حركة من شاشة التسجيل، وستظهر هنا فوراً.')}</div>`;
  }

  const sym = baseSym();
  const multi = state.members && state.members.length > 1;
  const byUser = new Map((state.members || []).map(m => [m.id, m.displayName || m.username]));

  let html = '', current = null, buffer = [], daySum = 0;

  const flush = () => {
    if (!buffer.length) return;
    html += `<div class="daylab"><span>${esc(current)}</span>
      <span class="mono">${fmt(daySum)} ${sym}</span></div>` + buffer.join('');
    buffer = []; daySum = 0;
  };

  for (const e of list){
    const label = dayLabel(new Date(e.occurredAt).getTime());
    if (label !== current){ flush(); current = label; }
    if (e.kind !== 'in') daySum += toBase(e);

    let row = entryRow(e);
    // في المحفظة المشتركة نبيّن من سجّل — أرخص طريقة لمنع «مين صرف هاي؟»
    if (multi && e.userId && e.userId !== state.user.id){
      const who = byUser.get(e.userId);
      if (who){
        row = row.replace('</span>\n    <span class="val">',
          `<span class="tag plain">${esc(who)}</span></span>\n    <span class="val">`);
      }
    }
    buffer.push(row);
  }
  flush();

  return topBar('السجل', 'اضغط أي حركة لتعديلها أو حذفها')
    + `<div class="scroll">${html}</div>`;
}

export function onClick(app, btn){
  if (btn.dataset.entry){
    app.openEdit(btn.dataset.entry);
    return;
  }
  return false;
}
